import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { ApiGetDataStatus, CustomerStateType } from '@redux/types'
import { Customer, CustomerType } from '@schemas'

// initial state
const initialState: CustomerStateType = {
	customerList: [],
	customerListStatus: 'init',
	editPasswordCustomer: new Customer(),
	resetPasswordErrorMessage: '',
	updateCustomer: {
		customerId: '',
		name: '',
		email: '',
		iudFlag: 'I',
		confirmEmailNewsYn: 0,
	},
	updateResetPassword: {
		customerId: '',
		password: '',
	},
	triggerInitCustomer: false,
}

const slice = createSlice({
	name: 'customer',
	initialState,
	reducers: {
		// trigger
		TRIGGER_INIT_CUSTOMER_PAGE: (
			state: CustomerStateType,
			action: PayloadAction<boolean>,
		) => {
			state.triggerInitCustomer = action.payload
		},

		// customers
		CUSTOMER_LIST: (state: CustomerStateType, action: PayloadAction<CustomerType[]>) => {
			state.customerList = action.payload
		},
		CUSTOMER_LIST_STATUS: (
			state: CustomerStateType,
			action: PayloadAction<ApiGetDataStatus>,
		) => {
			state.customerListStatus = action.payload
		},
		EDIT_PASSWORD_CUSTOMER: (
			state: CustomerStateType,
			action: PayloadAction<CustomerStateType['editPasswordCustomer']>,
		) => {
			state.editPasswordCustomer = action.payload
		},
		RESET_PASSWORD_ERROR_MESSAGE: (
			state: CustomerStateType,
			action: PayloadAction<string>,
		) => {
			state.resetPasswordErrorMessage = action.payload
		},
		UPDATE_RESET_PASSWORD: (
			state: CustomerStateType,
			action: PayloadAction<CustomerStateType['updateResetPassword']>,
		) => {
			state.updateResetPassword = action.payload
		},

		// updateCustomer
		UPDATE_CUSTOMER: (
			state: CustomerStateType,
			action: PayloadAction<CustomerStateType['updateCustomer']>,
		) => {
			state.updateCustomer = action.payload
		},
	},
})

export default slice.reducer
export const customerActions = slice.actions
